import { Controller, Loader } from '@tencent/workbench';
import { Form } from '@tencent/wb-ext-form';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import { IChartFontColorFeature } from './font-color-interface';
import { FORM_CONFIGS } from './config';
import type { IDynamicLoader } from '@tencent/workbench';

@Controller({ formItems: FORM_CONFIGS })
export class ChartFontColorController {
    constructor(@Loader(IChartFontColorFeature) private loader: IDynamicLoader<IChartFontColorFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(ChartFormItemKey.GLOBAL_FONT_COLOR, 'content')
    public getColorSelectButton(): JSX.Element {
        return this.feature.getColorSelectButton();
    }
}
